import { render, staticRenderFns } from "./SearchIngredientMaterial.vue?vue&type=template&id=d6615172&scoped=true&"
import script from "./SearchIngredientMaterial.vue?vue&type=script&lang=js&"
export * from "./SearchIngredientMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SearchIngredientMaterial.vue?vue&type=style&index=0&id=d6615172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6615172",
  null
  
)

export default component.exports